<template>
  <div class="pop">
    <div class="exceladd">
      <div class="title">试题导入</div>
      <div class="item">
        <span class="left">模板下载：</span>
        <span>
          <a class="down" href="../../static/试题导入模板.xlsx" download="试题导入模板.xlsx">Excel模板下载</a>
        </span>
      </div>
      <div class="item">
        <span class="left">试题分类：</span>
        <span>
          <Cascader
            style="width:250px;display:inline-block"
            :data="questiontype"
            @on-change="changed"
          ></Cascader>
        </span>
      </div>
      <div class="item">
        <span class="left">选择附件：</span>
        <Upload
          ref="upload"
          style="display:inline-block;margin-right:50px"
          :before-upload="befored"
          :show-upload-list="false"
          :multiple="false"
          action="/api/Question/excel"
          :on-success="success"
          accept=".xlsx"
          :data="data"
          name="file"
        >
          <Button type="primary">选择文件</Button>
          <span v-if="file&&file.name">{{file.name}}</span>
        </Upload>
      </div>
      <div class="item">
        <Button @click="upload" type="primary">开始导入</Button>
      </div>

      <!-- <div>
        <span v-if="errorshow">
          <span style="color:red" class="left">出现错误</span>
          <span>
            <Button type="primary" @click="exported" size="small">导出错误试题</Button>
          </span>
        </span>
      </div>-->
      <div class="result" v-if="show ==1">
        <span>{{rightnumber}}道题全部导入成功!</span>
      </div>
      <div class="result error" v-if="show ==2">
        <span>{{errornumber}}道题全部导入失败！</span>
        <Button @click="exported" type="error">导出错误试题</Button>
      </div>
      <div class="result warning" v-if="show ==3">
        <span>{{rightnumber}}道题全部导入成功，{{errornumber}}道题全部导入失败!</span>
        <Button @click="exported" type="error">导出错误试题</Button>
      </div>
      <div>
        <span class="button" @click="close">关闭</span>
      </div>
    </div>
  </div>
</template> 
<script>
import { Question_export } from "../assets/js/api.js";
export default {
  name: "addexcel",
  data() {
    return {
      value: null,
      errorshow: false,
      data: {
        id: null, //	string	true	普通参数		试题分类
        show: 1 //	string	true	普通参数		0不返回试题1返回试题详情
      },
      list: [],
      file: null,
      show: 0,
      errornumber: 0,
      rightnumber: 0,
      errordata:null
    };
  },
  computed: {
    questiontype() {
      return this.$store.state.questiontype;
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    changed(data) {
      // console.log(data)
      this.data.id = data.pop();
      // console.log(this.data.id)
    },
    befored(file) {
      // if (!this.data.id) {
      //   this.$Notice.error({ title: "错误提示", desc: "试题分类不能为空" });
      //   return false;
      // }
      this.file = file;
      return false;
    },
    upload() {
      if (!this.file) {
        this.errorPlus("请选择文件");
        return false;
      }
      if (!this.data.id) {
        this.$Notice.error({ title: "错误提示", desc: "试题分类不能为空" });
        return false;
      }
      this.$refs.upload.post(this.file);
    },
    success(data) {
      this.rightnumber =data.data.right?data.data.right.length:0
      this.errornumber = data.data.error?data.data.error.length:0
      if(this.errornumber==0){
        this.show = 1
      }
      if(this.rightnumber==0){
        this.show = 2
      }
      if((this.rightnumber>0)&&(this.errornumber>0)){
        this.show = 3
      }
      if(this.rightnumber>0){
        this.$emit("sure", data.data.right);
      }
      if(this.errornumber>0){
        this.errordata = data.data.error
      }
    },
    exported() {
      Question_export({error:this.errordata}).then(res => {
        this.loadExcel(res.data, "导入错误试题");
      }).catch(res=>{
        this.errorPlus("导出失败！")
      })
    }
  }
};
</script>
<style lang="css" scoped>
.pop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.5);
}
.exceladd {
  width: 800px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 0 20px 0 #ddd;
  box-sizing: border-box;
  padding: 20px 40px;
}
.title {
  line-height: 30px;
  font-size: 26px;
}
.item {
  height: 40px;
  margin-top: 20px;
  text-align: left;
  font-size: 16px;
}
.button {
  width: 100px;
  height: 34px;
  font-size: 16px;
  background: #4a4cff;
  line-height: 34px;
  color: #fff;
  display: inline-block;
  margin: 0 10px;
}
.button.none {
  background: none;
  color: #727982;
}
.down {
  width: 122px;
  height: 32px;
  background: #ffd6de;
  color: #ff245b;
  text-align: center;
  line-height: 32px;
  font-size: 14px;
  display: inline-block;
  text-decoration: none;
}
.result {
  box-shadow: 0 0 20px green;
  height: 50px;
  margin: 30px 0;
  border-radius: 5px;
  color: green;
  font-size: 0.18rem;
  line-height: 50px;
  font-weight: bold;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.result.error {
  box-shadow: 0 0 20px red;
  color: red;
}
.result.warning {
  box-shadow: 0 0 20px orange;
  color: orange;
}
</style>


// WEBPACK FOOTER //
// src/components/exceladd.vue